import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=3d5d4b3c&lang=html&"
import script from "./video-modal.vue?vue&type=script&lang=js&"
export * from "./video-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports